import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import aos from '@src/utils/aos';
import { observable } from 'mobx';
import { useRouteMatch } from 'react-router-dom';
import $$tracker from '@src/tracker';
class SuccessFullyStore extends BaseStore {
  @observable pageConfig = {};
  /**
   * 招聘模式 social：社招 campus：校招
   */
  @observable mode = 'social';

  @observable title = '';
  /**
   * 组织ID
   */
  // @observable orgId = 'xishanju-test';

  goList() {
    const url = this.mode === 'social' ? 'jobList.html' : 'campusList.html';
    this.jumpPage(url);
  }

  /**
   * 查看投递记录
   */
  clickJobRecord() {
    const url = this.mode === 'social' ? 'jobRecord.html' : 'campusRecord.html';
    this.jumpPage(url);
  }

  use() {
    super.use();
    this.$routeMatch = useRouteMatch();
    useMount(async () => {
      $$tracker.loadPageTdcg();
      const { title } = this.$routeMatch.query;

      if (title) {
        this.title = decodeURIComponent(title);
      }

      aos.reInit();

      window.__FUN_LINK_PAGE_DATA_PROMISE__.then(res => {
        const { data, status } = res;
        // console.log('data', data.pageConfig);
        this.mode = data.modeConfig.mode;
        this.pageConfig = data.pageConfig;
      });
    });
  }
}

export default SuccessFullyStore;
